module.exports = __webpack_public_path__ + "img/big-banner.fa2f19b0.png";